// removed by extract-text-webpack-plugin
module.exports = {"poster-type-content":"poster-type-content","type-container":"type-container","type-container-disable":"type-container-disable","type-title":"type-title","type-description":"type-description","type-btn":"type-btn","disabled":"disabled"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/PosterType/Modal.scss
// module id = kOwV
// module chunks = 0